module.exports = __webpack_public_path__ + "static/media/nointerest.1fba0bdc.png";